(function () {
  'use strict';

  angular.module('app').component('vehicleList', vehicleList());

  function vehicleList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
      },
      controller: VehicleListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/vehicles/vehicle-list/vehicle-list.component.html',
    };
  }

  VehicleListComponent.$inject = ['UtilService', 'AbilityService', 'VehicleService'];

  function VehicleListComponent(UtilService, AbilityService, VehicleService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_vehicle_accountadmin'),
      canUpdate: AbilityService.can('update_vehicle_accountadmin'),
      canDestroy: AbilityService.can('destroy_vehicle_accountadmin'),
    };

    vm.filterCriteria = VehicleService.getFilterCriteria();

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      VehicleService.getVehicles(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      vm.fetchResult();
    };

    vm.showItem = function (item) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item });
    };

    vm.deleteItem = function (item) {
      VehicleService.deleteVehicle(item, vm.fetchResult);
    };

    vm.changeItemStatus = function (item) {
      VehicleService.changeVehicleStatus(item);
    };
  }
})();
